import { Grid } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FundingSources } from '~/modules/identification/forms/FinancialCondition/components/FundingSources.tsx';
import { styles } from '../styles.ts';
import FormGridItem from '~/components/FormComponents/FormGridItem';

export const BlockFinancialLegalResident = () => {
  return (
    <Grid container spacing={3} sx={styles.wrapper}>
      <FormGridItem>
        <FormInput
          name="securitiesNominalValue"
          label={'Загальна номінальна вартість цінних паперів у власності'}
          placeholder={'Введіть загальну номінальну вартість цінних паперів'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="netIncomeFromSales"
          label={'Чистий дохід від реалізації продукції (товарів, робіт, послуг)'}
          placeholder={'Введіть чистий дохід від реалізації продукції (товарів, робіт, послуг)'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="totalLoanDebt"
          label={'Заборгованість за кредитами в інших банках'}
          placeholder={'Введіть заборгованість за кредитами в інших банках'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="debtFromNonResidentLoans"
          label={'Заборгованість за кредитами, отриманими від нерезидентів'}
          placeholder={'Введіть заборгованість за кредитами, отриманими від нерезидентів'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="costOfGoodsSold"
          label={'Собівартість реалізованої продукції (товарів, робіт, послуг)'}
          placeholder={'Введіть собівартість реалізованої продукції (товарів, робіт, послуг)'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="grossProfitOrLoss"
          label={'Валовий прибуток/збиток (фінансовий результат до оподаткування)'}
          placeholder={'Введіть валовий прибуток/збиток (фінансовий результат до оподаткування)'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="nonCurrentAssets"
          label={'Розмір необоротних активів'}
          placeholder={'Введіть розмір необоротних активів'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="totalDeposits"
          label={'Загальна сума депозитів'}
          placeholder={'Введіть загальну суму депозитів'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="currentAssets"
          label={'Розмір оборотних активів'}
          placeholder={'Введіть розмір оборотних активів'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="currentLiabilities"
          label={'Розмір поточних зобов’язань'}
          placeholder={'Введіть розмір поточних зобов’язань'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="equity"
          label={'Розмір власного капіталу'}
          placeholder={'Введіть розмір власного капіталу'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="salesExpenses"
          label={'Витрати на збут'}
          placeholder={'Введіть розмір витрат на збут'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="plannedMonthlyInflows"
          label={
            'Обсяг фінансових операцій (надходження коштів), які планує проводити клієнт протягом місяця по усіх рахунках (еквівалент в грн.) в АТ «Укрексімбанк»'
          }
          placeholder={'Введіть еквівалент в гривні'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="maxMonthlyInflows"
          label={
            'Максимальна сума фінансових операцій (надходження коштів) на місяць (еквівалент в грн.)'
          }
          placeholder={'Введіть еквівалент в гривні'}
          fullWidth
        />
      </FormGridItem>
      <FundingSources />
    </Grid>
  );
};
